module.exports = __webpack_public_path__ + "img/s03-bg1.c515746e.jpg";